/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_TitleInputs */

const en_landing_hero_title = /** @type {(inputs: Landing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your research. Your clients. Your commissions.`)
};

/**
* | output |
* | --- |
* | "Your research. Your clients. Your commissions." |
*
* @param {Landing_Hero_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_title = /** @type {((inputs?: Landing_Hero_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_hero_title(inputs)
});